import { Typography } from "@mui/material";
import { useEffect, useState } from "react";

import Modal from "../../../global/Modal";
import HNSColors from "../../../ui library/HNSColors";
import useContractsEditModal from "../hooks/useContractsEditModal";

import ContractsActionButtons from "./modal/ContractsActionButtons";
import ContractsEditForm from "./modal/ContractsEditForm";

export default function ContractsEditModal(props) {
  const { openModal, contractData, handleCloseModal, mode = "edit" } = props;
  const [displayMode, setDisplayMode] = useState(mode);
  const { formValues, isDirty, isSaving, handleFieldOnChange, handleCancel, handleSave } =
    useContractsEditModal(props);

  useEffect(() => {
    if (openModal) {
      setDisplayMode(mode);
    }
  }, [mode, openModal]);

  if (mode === "edit" && !contractData) {
    return null;
  }

  return (
    <Modal open={openModal} onClose={handleCloseModal} maxWidth="md">
      <div>
        <div className="px-6 pt-6">
          <Typography className="text-[20px] font-semibold" sx={{ color: HNSColors.neutrals[100] }}>
            {displayMode === "add" ? "Add Contract" : "Edit Contract"}
          </Typography>
        </div>
        <ContractsEditForm formValues={formValues} onChange={handleFieldOnChange} mode={mode} />
        <ContractsActionButtons
          disableCancel={!isDirty || isSaving}
          disableSave={!isDirty || isSaving}
          handleOnClickCancelBtn={handleCancel}
          handleOnClickSaveButton={handleSave}
        />
      </div>
    </Modal>
  );
}
